"use client";

import { useCallback } from "react";

export function useQueryParam() {
  const getParam = useCallback((key: string): string | null => {
    const params = new URLSearchParams(window.location.search);
    return params.get(key);
  }, []);

  const setParam = useCallback((key: string, value: string) => {
    const params = new URLSearchParams(window.location.search);
    params.set(key, value);

    const url = window.location.pathname + (params.toString() ? `?${params.toString()}` : "");

    window.history.replaceState(null, "", url);
  }, []);

  const deleteParam = useCallback((key: string) => {
    const params = new URLSearchParams(window.location.search);
    params.delete(key);

    const url = window.location.pathname + (params.toString() ? `?${params.toString()}` : "");

    window.history.replaceState(null, "", url);
  }, []);

  return { getParam, setParam, deleteParam };
}
